import { FormSelector, Modal, Toast } from "@vesatogo/grass-core"
import { useState } from "react"
import toast from "react-hot-toast"
import { useSearchParams } from "react-router-dom"
import {
  useAllCreditStatusQuery,
  useCreditStatusQuery,
  useUpdateCreditStatusMutation,
} from "~/generated/graphql"

export type CreditActionType = {
  //   onClose?: any
}

export const CreditAction = ({}: CreditActionType) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const isOpen = searchParams.get("action")
  const id = searchParams.get("id")

  const [option, setOption] = useState<any>()
  const onClose = () => {
    searchParams.delete("action")
    searchParams.delete("id")
    setSearchParams(searchParams)
  }

  const [{ data }] = useCreditStatusQuery({
    variables: {
      id: id,
    },
    pause: !id,
  })

  const [{ data: optionData }] = useAllCreditStatusQuery({
    variables: {
      where: {
        parents: {
          to_creditstatus_id: { _eq: data?.credit_by_pk?.status?.id },
        },
        is_actionable: { _eq: true },
      },
    },
  })

  const options = optionData?.credit_status

  const [, updateCreditStatus] = useUpdateCreditStatusMutation()

  const credit = data?.credit_by_pk
  return (
    <Modal
      title="Action"
      primaryActionButtonProps={{
        text: "Update",
        onClick: async () => {
          const { error } = await updateCreditStatus({
            input: {
              id: credit?.id,
              status_id: option?.id,
            },
          })
          if (error) {
            return toast.custom(
              <Toast
                intent="danger"
                title={"Something went wrong! " + error.message}
              />
            )
          }
          onClose()
          searchParams.set("updated", Date())
          setSearchParams(searchParams)
          return toast.custom(
            <Toast title={"Status changed to " + option?.id} />
          )
        },
      }}
      secondaryActionButtonProps={{
        text: "Cancel",
        onClick: onClose,
      }}
      onClose={onClose}
      isOpen={Boolean(isOpen)}
      bodyClassName="max-w-lg overflow-visible"
    >
      <FormSelector
        options={options}
        value={option}
        getOptionLabel={op => op?.id}
        onChange={e => {
          setOption(e)
        }}
      />
    </Modal>
  )
}

export default CreditAction
